import { Component, Inject, Input } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FieldOkItemComponent } from "@softline/dynamic";

@Component({
    selector: 'soft-field-ok-data-view',
    imports: [CommonModule],
    templateUrl: './vkforg.list-view.html',
    styleUrls: ['./vkforg.list-view.scss']
})
export class VkforgListView implements FieldOkItemComponent<any>{

  @Input() item: any;

  constructor() {
  }
}
